import { Pricing } from '@nemuru-eng/js-api-client';
import React, { Dispatch, SetStateAction } from 'react';

import { PricingDetailDialog } from '@/components/shared/components/PricingsTable/components/PricingActionsRowDialog/components/PricingDetailDialog';
import { RemovePricingFromAgentDialog } from '@/components/shared/components/PricingsTable/components/PricingActionsRowDialog/components/RemovePricingFromAgentDialog';
import { PricingRowActionType } from '@/components/shared/components/PricingsTable/types/PricingRowActionType';

interface PricingActionsRowDialogProps {
  selectedPricing: Pricing;
  pricingAction: PricingRowActionType;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
  setRowPricingAction?: Dispatch<React.SetStateAction<PricingRowActionType | undefined>>;
  refreshData: () => Promise<unknown>;
  editModeAllowed?: boolean;
}

export const PricingActionsRowDialog = ({
  selectedPricing,
  pricingAction,
  opened,
  setOpened,
  toggleDialog,
  setRowPricingAction,
  refreshData,
  editModeAllowed,
}: PricingActionsRowDialogProps) => {
  return (
    <>
      {pricingAction === PricingRowActionType.SEE_PRICING_DETAIL && (
        <PricingDetailDialog
          pricing={selectedPricing}
          opened={opened}
          setOpened={setOpened}
          handleClose={toggleDialog}
          refreshData={refreshData}
          editModeAllowed={editModeAllowed}
        />
      )}
      {pricingAction === PricingRowActionType.REMOVE_PRICING_FROM_AGENT && (
        <RemovePricingFromAgentDialog
          opened={opened}
          setOpened={setOpened}
          selectedPricing={selectedPricing}
          setRowPricingAction={setRowPricingAction}
        />
      )}
    </>
  );
};
